exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.api-card[data-v-4fd0fe90] {\n  border: 1px solid #e6e8ef;\n  border-radius: 8px;\n}\n", ""]);

// exports
